import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Button, Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCalendarAlt, faClock, faFileAlt, faUser, faCheckCircle, faTimesCircle, faEdit } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';

const AbsenceDetailsPanel = ({ absence, onClose }) => {
  const navigate = useNavigate();
  
  if (!absence) return null;

  // Formatta le date in modo leggibile
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd MMMM yyyy', { locale: it });
    } catch (error) {
      console.error('Errore nel formato della data:', error);
      return dateString;
    }
  };

  // Formatta l'orario in modo leggibile
  const formatTime = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, 'HH:mm', { locale: it });
    } catch (error) {
      console.error('Errore nel formato dell\'orario:', error);
      return '';
    }
  };

  // Estrae il tipo di assenza dal titolo se disponibile
  const absenceType = absence.absenceType ? 
    absence.absenceType.charAt(0).toUpperCase() + absence.absenceType.slice(1) : 
    'Non specificato';

  // Estrae il nome utente dal titolo
  const userLabel = absence.userLabel || 'Collaboratore';
  
  // Gestione dello stato di approvazione
  const approvalStatus = absence.approved ? 
    <Badge color="success" className="d-flex align-items-center">
      <FontAwesomeIcon icon={faCheckCircle} size="sm" className="mr-1" /> Approvata
    </Badge> : 
    <Badge color="warning" className="d-flex align-items-center">
      <FontAwesomeIcon icon={faTimesCircle} size="sm" className="mr-1" /> In attesa
    </Badge>;

  return (
    <div className="absence-details-panel">
      <Card className="shadow-lg">
        <CardHeader className="d-flex justify-content-between align-items-center" 
          style={{ backgroundColor: absence.backgroundColor || '#4299E1' }}>
          <h5 className="m-0 text-white">Dettagli Assenza</h5>
          <Button close onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} className="text-white" />
          </Button>
        </CardHeader>
        
        <CardBody>
          <div className="mb-3">
            <h5>{absenceType}</h5>
            <div className="d-flex align-items-center mb-2">
              <FontAwesomeIcon icon={faUser} className="mr-2" />
              <span>{userLabel}</span>
            </div>
            <div className="d-flex align-items-center mb-2">
              <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" />
              <span>
                {formatDate(absence.start)} - {formatDate(absence.end)}
              </span>
            </div>
            <div className="d-flex align-items-center mb-2">
              <FontAwesomeIcon icon={faClock} className="mr-2" />
              <span>
                {formatTime(absence.start)} - {formatTime(absence.end)}
              </span>
            </div>
          </div>
          
          {absence.notes && (
            <div className="mb-3">
              <h6 className="d-flex align-items-center">
                <FontAwesomeIcon icon={faFileAlt} className="mr-2" />
                Note
              </h6>
              <p className="p-2 bg-light rounded">{absence.notes}</p>
            </div>
          )}
          
          <div className="d-flex justify-content-between align-items-center">
            <span>Stato approvazione:</span>
            {approvalStatus}
          </div>
        </CardBody>
        
        <CardFooter className="d-flex justify-content-between">
          <Button 
            color="primary" 
            onClick={() => {
              // Chiudi la modale
              onClose();
              // Naviga alla pagina delle assenze con l'ID per la modifica
              navigate(`/employeeAbsences?edit=${absence.absenceId}`);
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Modifica
          </Button>
          <Button color="secondary" onClick={onClose}>
            Chiudi
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AbsenceDetailsPanel;
